import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Nshock } from '../nshock';

@Component({
    selector: 'nsm2',
    templateUrl: './nsm2.component.html',
    styleUrl: './nsm2.component.scss',
    standalone: false
})
export class Nsm2Component implements OnInit {

  m2Form: FormGroup | undefined;
  m2Bool?: boolean;
  m2Shock: Nshock | undefined;

  constructor(private fBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.m2Form = this.fBuilder.group({
      gVal: ['', [
        Validators.required,
        Validators.min(1.000001),
        Validators.max(1.67)        
      ]],
      m2Val: ['', [
        Validators.required,
        Validators.min(.377965),
        Validators.max(1.000001)
      ]]
    })
  }

  onSubmit(): void {
    this.m2Bool = true;
    this.m2Shock = new Nshock();
    this.m2Shock.gammaVal = this.m2Form?.get('gVal')?.value;
    this.m2Shock.m2 = this.m2Form?.get('m2Val')?.value;
    this.m2Shock.m1 = Number(this.m1_from_m2(this.m2Shock.gammaVal, this.m2Shock.m2));
    console.log("M1 = ", this.m2Shock.m1);
    this.m2Shock.nShockCalc(this.m2Shock.gammaVal, this.m2Shock.m1);
    
  }

  m1_from_m2(g:number, m2:number): number {
    console.log("g = ", g);
    console.log("m2 = ", m2);
    let gm1 = g-1;
    let result = Math.sqrt((1. + .5 * gm1 * m2 * m2) / (g * m2 * m2 - .5 * (g - 1.)));
    console.log("result = ", result);
    
    return Number(result.toFixed(2));
  }


  nsm1() {
    return this.m2Shock?.m1;
  }

  nsp2p1() {
    return this.m2Shock?.p2p1;
  }

  nsdva1() {
    return this.m2Shock?.dva1;
  }

  nspt2_pt1() {
    return this.m2Shock?.pt2pt1;
  }

  nspt2_p1() {
    return this.m2Shock?.pt2p1;
  }

  nst2t1() {
    return this.m2Shock?.t2t1;
  }

}
